import { useLocation, useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

import { percomaticLoadedState } from '../../../atoms';
import { Skeleton as ItemsSkeleton } from '../Items/Skeleton';
import { Totals } from '../Totals';
import { BalanceDue } from '../../../Checkout/components/BalanceDue';
import { Divider } from '../../../components/Divider';
import { Flex } from '../../../GlobalComponents/Flex';
import { Button } from '../../../GlobalComponents/Button';
import { useAppSelector } from '../../../reduxstore/hooks';
import {
	cartQuantityState,
	currentTransactionState,
	sessionCartState
} from '../../atoms';
import { CartItem } from '../CartItem';

export const CartSummary: React.FC = () => {
	const { items, subTotal, taxAmount, total } = useRecoilValue(
		currentTransactionState
	);
	const location = useLocation();
	const navigate = useNavigate();
	const percomaticLoaded = useRecoilValue(percomaticLoadedState);
	const cartQuantity = useRecoilValue(cartQuantityState);
	const sessionCart = useRecoilValue(sessionCartState);
	const balanceDue = useAppSelector(
		state => state.checkoutReducer.balanceDue
	);

	return (
		<div id="cart-summary">
			{percomaticLoaded ? (
				cartQuantity !== 0 ? (
					<>
						{items.map(item => (
							<CartItem
								key={item.id}
								{...item}
								productId={`${item.product.id}`}
								name={`${item.product.name}`}
							></CartItem>
						))}

						<Totals
							subTotal={subTotal}
							total={total}
							taxAmount={taxAmount}
						/>
						{!location.pathname.includes('cart') && (
							<BalanceDue balanceDue={balanceDue} />
						)}
						{location.pathname.includes('cart') && (
							<Flex
								$placeContent="center flex-end"
								$flexDirection="row"
								$alignItems="center"
								$padding="15px 0 0 0"
							>
								<Button onClick={() => navigate('/checkout')}>
									Proceed to Checkout
								</Button>
							</Flex>
						)}
					</>
				) : (
					<Flex
						$margin="200px 0"
						$flexDirection="column"
						$placeContent="center"
						$alignItems="center"
						$rowGap="20px"
						$height="auto"
					>
						<Text>
							Your cart is empty. <br />
							Ready to order a drink?
						</Text>
						<Button onClick={() => navigate('/menu')}>
							Go to Menu
						</Button>
					</Flex>
				)
			) : (
				<ItemsSkeleton
					key={`ItemsSkelton${sessionCart.id}`}
					numItems={sessionCart.items.length}
					divider={<Divider my={2} borderColor="light" />}
					editable
				/>
			)}
		</div>
	);
};

const Text = styled.div`
	font-size: 24px;
	font-weight: 500;
	text-align: center;
`;
